import requestFunctions from "../../functions/requestFunctions";


export const state = {
  ACTIONS_ITEM: {},
  ACTIONS_LIST: [],
  ACTIONS_TABLE_DATA: [],
  ACTIONS_LIST_DATA: [],
  ACTIONS_TOTAL_ROWS: 0
}

export const getters = {
  GET_ACTIONS_ITEM: (state) => {
    return state.ACTIONS_ITEM;
  },
  GET_ACTIONS_LIST: (state) => {
    return state.ACTIONS_LIST;
  },
  GET_ACTIONS_TABLE_DATA: (state) => {
    return state.ACTIONS_TABLE_DATA;
  },
  GET_ACTIONS_LIST_DATA: (state) => {
    return state.ACTIONS_LIST_DATA;
  },
  GET_ACTIONS_TOTAL_ROWS: (state) => {
    return state.ACTIONS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_ACTIONS_ITEM(state, item) {
    state.ACTIONS_ITEM = item;
  },

  UPDATE_ACTIONS_LIST(state, list) {
    
    state.ACTIONS_LIST = list.data;

    state.ACTIONS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.ACTIONS_TABLE_DATA = [];
    state.ACTIONS_LIST_DATA = [];

    list.forEach(el => {

      state.ACTIONS_TABLE_DATA.push({
        'id' : el.id,
        'name' : el.name,
        'product_name' : el.product_name,
        'code' : el.code,
        'uuid' : el.uuid
      });

      state.ACTIONS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
        code: el.code
      });
    });
  },
}

export const actions = {

  async FETCH_ACTIONS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/actions/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ACTIONS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_ACTIONS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/actions';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_ACTIONS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_ACTIONS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/actions';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_ACTIONS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/actions/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_ACTIONS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/actions/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}